<script>
import RepositorySearch from "../../abstract/RepositorySearch.js";

import SubjectTypeSelect from "../../forms/models/subject/components/SubjectTypeSelect";
import TypeSelect from "./index/components/TypeSelect.vue";
import NameField from "./index/components/NameField.vue";

export default RepositorySearch.extend({
  components: {
    SubjectTypeSelect,
    TypeSelect,
    NameField
  },
  data() {
    return {
      options: {
        student_type: "*",
        title: "",
        semesters: [],
        my_subjects: true,
        type: {
          name: null,
          details: {
            theoretical: null,
            department: null,
            type: null
          }
        }
      },
      sortColumn: "student_type",
      syncOrder: {
        title: "asc",
        student_type: "asc"
      },
      endpoint: "/api/subjects",
      limit: 50,
      course: null,
      semester: null
    };
  },
  computed: {
    isBachelor: function() {
      return this.options.student_type == "bachelor";
    },
    isMaster: function() {
      return this.options.student_type == "master";
    },
    isGraduate: function() {
      return this.options.student_type == "graduate";
    },
    isAny: function() {
      return this.options.student_type == "*";
    },
    semesters() {
      let semesters = [];
      for (let semester = 1; semester <= 8; semester++) {
        let exists =
          this.isBachelor ||
          this.isAny ||
          (this.isMaster && semester <= 4) ||
          (this.isGraduate && semester <= 6);

        semesters.push({
          exists: exists,
          number: semester
        });
      }

      return semesters;
    },
    courses() {
      let courses = [];

      for (let course = 1; course <= 4; course++) {
        let exists =
          this.isBachelor ||
          this.isAny ||
          (this.isMaster && course <= 2) ||
          (this.isGraduate && course <= 3);

        courses.push({
          exists: exists,
          number: course
        });
      }

      return courses;
    }
  },
  methods: {
    mergeOptions: function(options) {
      return _.merge(
        {
          with: ["semesters"]
        },
        options
      );
    },
    clear: function() {
      this.options.title = "";
    },
    show: function(subject) {
      window.open(subject.url, "_self");
    },
    courseChanged() {
      this.semesters = 1;
    },
    onTypeChange(type) {
      this.resetTable();
      this.semesters.forEach(semester => {
        if (
          semester.number == _.first(this.options.semesters) &&
          !semester.exists
        ) {
          this.onSemesterClear();
          return;
        }
      });
    },
    onCourseChange(course) {
      this.$nextTick(() => {
        this.semester = null;
        if (this.course != null) {
          this.options.semesters = [2 * this.course - 1, 2 * this.course];
        } else {
          this.options.semesters = [];
        }
      });
    },
    onSemesterChange(semester) {
      this.$nextTick(() => {
        this.course = null;
        this.options.semesters = [this.semester];
      });
    },
    onSemesterClear() {
      this.course = null;
      this.semester = null;
      this.options.semesters = [];
    },
    typeParameterFilter(value) {
      return _.pick(value, [
        "name",
        "details.theoretical",
        "details.department.id",
        "details.type"
      ]);
    }
  },
  mounted() {
    let semester = parseInt(_.last(this.options.semesters));
    if (this.options.semesters.length == 1) {
      this.semester = semester;
    } else if (this.options.semesters.length == 2) {
      this.course = Math.ceil(semester / 2);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/subjects/Index.vue